var cubigoAppVersion={build:'190'};

var deviceInformation = {
    id: null
};
